module.exports = __webpack_public_path__ + "static/img/image_like.3ca72b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_like.png
// module id = qYJT
// module chunks = 1